// extracted by mini-css-extract-plugin
export default {"loader":"SelectVoucher_loader__QqlpH","notFound":"SelectVoucher_notFound__4xl-L"};